module.exports = __webpack_public_path__ + "img/example-left-mobile.f49bf2e.png";